class FortuneInvestmentAim {
    id!:            number;
    description!:   string;
    plannedAmount!: number;
    plannedDate!:   Date;
}

export default FortuneInvestmentAim;